import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getStockByProduct = async (productId, businessId = null, branchId = null, pageNumber = 1, pageSize = 50, batchNumberSearch = null) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/PurchaseOrder/get-stock-by-product`, {
      Product_Id: productId,
      Business_Id: businessId,
      Branch_Id: branchId,
      PageNumber: pageNumber,  // NEW: Pagination support
      PageSize: pageSize,  // NEW: Pagination support
      BatchNumberSearch: batchNumberSearch  // NEW: Server-side search
    }, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching stock by product:", error);
    throw error;
  }
};
